'use client';

import { TextLink } from '@petsmart-ui/sparky';

import { trackNavigationHeaderClick } from '../../shared';

type TopHeaderLinkProps = {
    label: string;
    openInNewTab: boolean;
    url: string;
};

export function TopHeaderLink({ url, label, openInNewTab }: Readonly<TopHeaderLinkProps>) {
    function handleClick() {
        trackNavigationHeaderClick({
            selection: label.toLowerCase(),
            linkUrl: url,
        });
    }

    return (
        <TextLink
            className="sparky-u-display-block"
            variant="secondary"
            href={url}
            rel={openInNewTab ? 'noopener noreferrer' : undefined}
            target={openInNewTab ? '_blank' : undefined}
            onClick={handleClick}
        >
            {label}
        </TextLink>
    );
}
